import { API_BASE } from './api.js';
export async function checkIfSignedIn() {
    let data = await fetch(`${API_BASE}/`, {
        method: "get",
        credentials: 'include'
    });
    let response = await data.json();
    let signedIn = response.isSignedIn;
    return signedIn;
}

// module.exports = { checkIfSignedIn };